/* eslint-disable */
import { Component } from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import List from "@material-ui/core/List";
import {FormControl, FormLabel} from "@chakra-ui/react";
import {createStyles, Theme, withStyles} from "@material-ui/core";
import {B4FText} from "../B4FFields/B4FText";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {edit_Properties, getAllProperties} from "../../../utils/store/actions/users.actions";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    downloadBS: {
      margin: "20px",
    },
    dropzone: {
      fontSize: "8px",
      minHeight: 0,
      border: "dashed 0.8px #919191",
      borderRadius: "10px",
      "& .MuiDropzoneArea-icon": {
        color: "#ae0064",
      },
      "& .MuiDropzoneArea-text": {
        fontSize: "14px",
        margin: 0,
      },
      "& .MuiDropzoneArea-textContainer": {
        margin: "10px",
      },
    },
    dropzoneEmail: {},
    previewChip: {
      maxWidth: "300px",
      color: "#ae0064",
    },
  });
class HelpCenterClient extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }
  handleChangeProperty(e: any, prop: any) {
    this.props.edit_Properties({
      key: prop.key,
      value: e.target
        ? e.target.checked !== undefined
          ? e.target.checked
          : e.target.value
        : e.value,
    });
  }
  render() {
    const { classes, t } = this.props;
    return (
      <Accordion
        className={classes.accordion}
        style={{ flexDirection: "column" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#AE0064" }} />}
          aria-controls="panel2a-content"
          id="modules"
        >
          <Typography className={classes.heading}>{"Help center client"}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List className={classes.root}>
            {(this.props.Users?.get_properties || [])?.map(
              (property: any) =>
                property.key === "HELP_CENTER_LINK" && (
                  <FormControl id="link">
                    <FormLabel>{t(property.key)}</FormLabel>
                    <B4FText
                      value={this.state.linkCustomer || property.value}
                      onChange={(e: any) => {
                        this.setState({ linkCustomer: e.value });
                      }}
                      onBlur={(e: any) => {
                        this.handleChangeProperty(e, property);
                      }}
                      label=""
                      id="link"
                      key="link"
                      isDisabled={false}
                      isRequired={false}
                      visible={true}
                    />
                  </FormControl>
                )
            )}
          </List>
        </AccordionDetails>
        <AccordionDetails>
          <List className={classes.root}>
            {(this.props.Users?.get_properties || [])?.map(
              (property: any) =>
                property.key === "SUPPORT_EMAIL_ADDRESS" && (
                  <FormControl id="email">
                    <FormLabel>{t(property.key)}</FormLabel>
                    <B4FText
                      value={this.state.email || property.value}
                      onChange={(e: any) => {
                        this.setState({ email: e.value });
                      }}
                      onBlur={(e: any) => {
                        this.handleChangeProperty(e, property);
                      }}
                      label=""
                      id="email"
                      key="email"
                      isDisabled={false}
                      isRequired={false}
                      visible={true}
                    />
                  </FormControl>
                )
            )}
          </List>
        </AccordionDetails>
        <AccordionDetails>
          <List className={classes.root}>
            {(this.props.Users?.get_properties || [])?.map(
              (property: any) =>
                property.key === "CUSTOMER_SUPPORT_OPERATOR_NAME" && (
                  <FormControl id="nameOperator">
                    <FormLabel>{t(property.key)}</FormLabel>
                    <B4FText
                      value={this.state.nameCustomer || property.value}
                      onChange={(e: any) => {
                        this.setState({ nameCustomer: e.value });
                      }}
                      onBlur={(e: any) => {
                        this.handleChangeProperty(e, property);
                      }}
                      label=""
                      id="name"
                      key="name"
                      isDisabled={false}
                      isRequired={false}
                      visible={true}
                    />
                  </FormControl>
                )
            )}
          </List>
        </AccordionDetails>
        <AccordionDetails>
          <List className={classes.root}>
            {(this.props.Users?.get_properties || [])?.map(
              (property: any) =>
                property.key === "PHOTO_OF_THE_STAND" && (
                  <FormControl id="personPhoto">
                    <FormLabel>{t(property.key)}</FormLabel>
                    <B4FText
                      value={this.state.photoCustomer || property.value}
                      onChange={(e: any) => {
                        this.setState({ photoCustomer: e.value });
                      }}
                      onBlur={(e: any) => {
                        this.handleChangeProperty(e, property);
                      }}
                      label=""
                      id="photo"
                      key="photo"
                      isDisabled={false}
                      isRequired={false}
                      visible={true}
                    />
                  </FormControl>
                )
            )}
          </List>
        </AccordionDetails>
      </Accordion>
    );
  }

}
const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getAllProperties,
  edit_Properties
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(HelpCenterClient)));
